import { render, staticRenderFns } from "./HelpCenterFeedback.vue?vue&type=template&id=ca24a994&scoped=true"
import script from "./HelpCenterFeedback.vue?vue&type=script&lang=js"
export * from "./HelpCenterFeedback.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterFeedback.vue?vue&type=style&index=0&id=ca24a994&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca24a994",
  null
  
)

export default component.exports